export default __webpack_public_path__ + "static/media/light.ef85001a.svg";